module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', {
    staticStyle: {
      "font-family": "Calisto MT",
      "font-size": "18pt",
      "letter-spacing": "1px",
      "padding-top": "75px",
      "padding-bottom": "15px"
    }
  }, [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Sandy Schleiffers is one of the pioneer women jockeys of yesteryear. She is the fourth woman jockey in US history to win a thoroughbred race at a pari-mutuel track. She is also the first woman jockey to be licensed and to win a race in both Arizona and Colorado history. In addition, she is the first woman admitted to the men’s Jockey Guild. Sandy rode thoroughbred races for 7 years from 1969 to 1976. At the end of 1976, Sandy retired from racing and returned to school. She finished her bachelor’s degree, a master’s degree, and finally a PhD in 1985. She is the only jockey male or female to earn a PhD Sandy is currently retired after a successful career as a lecturer at Colorado State University where she taught for 25 years.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0